import { CalculatorDescription } from '../../../lib/calculators/calculator-description';
import { CalculatorId } from '../../../lib/calculators/calculator-config';

export const normalDescription: CalculatorDescription = {
  id: CalculatorId.NORMAL_DISTRIBUTION,
  title: 'Normal Distribution Calculator',
  metaTitle: 'Online Normal Distribution Calculator - Probability & Statistics Tool',
  description: 'Calculate probabilities and z-scores for normal distributions. Perfect for statistical analysis and probability calculations.',
  metaDescription: 'Calculate normal distribution probabilities online. Analyze z-scores and probability densities with our free statistics calculator.',
  howTo: {
    title: 'How to Use Normal Distribution Calculator',
    steps: [
      'Enter the mean (μ)',
      'Set the standard deviation (σ)',
      'Input a value (x) to calculate its probability',
      'View the z-score and probability results',
      'Analyze the distribution visualization'
    ]
  },
  examples: [
    {
      title: 'Test Scores Analysis',
      description: 'Analyzing standardized test scores',
      dataDescription: 'Test scores following a normal distribution',
      insights: [
        'Calculate percentile ranks',
        'Determine z-scores for specific scores',
        'Find probability of scoring within ranges',
        'Visualize score distribution'
      ]
    },
    {
      title: 'Quality Control',
      description: 'Analyzing manufacturing measurements',
      dataDescription: 'Product measurements following normal distribution',
      insights: [
        'Calculate probability of defects',
        'Determine specification limits',
        'Analyze process capability',
        'Monitor quality metrics'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.BINOMIAL_DISTRIBUTION,
    CalculatorId.ANOVA
  ]
}; 